module.exports = __webpack_public_path__ + "static/img/batsu.3a4aa14.png";